export default __webpack_public_path__ + "static/media/NewMalden.7909bc58.png";